import APIPage from "@/components/products/api/APIPage"

type Props = {}

const index = (_props: Props) => {
  return <APIPage />
}

export default index
